module.exports = __webpack_public_path__ + "img/paiming.01925396.png";